import { Button } from '@sunwebgroup/uds-ui/button'
import { Divider } from '@sunwebgroup/uds-ui/divider'
import { Icon } from '@sunwebgroup/uds-ui/icon'
import { Popover } from '@sunwebgroup/uds-ui/popover'
import { RadioButton, RadioButtonGroup } from '@sunwebgroup/uds-ui/radio-button'
import { RichText } from '@sunwebgroup/uds-ui/rich-text'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import { useBreakpoints } from '@sunwebgroup/ui-components/uds' // TODO: migrate to @sunwebgroup/uds-ui when available
import { type MouseEvent, useState } from 'react'
import { useIntl } from '@/intl'
import styles from './AirportDropdown.module.css'

function stopProductCardClick(event: MouseEvent) {
  event.stopPropagation()
}

interface AirportDropdownProps {
  airportCode: string
  airportName: string
}

export function AirportDropdown({ airportCode, airportName }: AirportDropdownProps) {
  const [isOpened, setIsOpened] = useState(false)
  const { isMobile } = useBreakpoints()
  const intl = useIntl()

  return (
    <Popover.Root open={isOpened} modal={isMobile} onOpenChange={setIsOpened}>
      <Popover.Trigger>
        <Button className={styles.button} variant="secondary" onClick={stopProductCardClick}>
          <div className={styles.buttonContent}>
            <Icon glyph="AirplaneTakingOff" size={20} />
            <Typography variant="body-m-regular-tight">{airportCode}</Typography>
            {isOpened ? <Icon glyph="ChevronUpExtraSmall" size={24} /> : <Icon glyph="ChevronDownExtraSmall" size={24} />}
          </div>
        </Button>
      </Popover.Trigger>

      <Popover.Content
        className={styles.content}
        title={intl.formatMessage({ id: 'quicksearch_filter_departure_airport_title' })}
        closeText={intl.formatMessage({ id: 'close' })}
        hasPadding={false}
        position="bottom-right"
        onClick={stopProductCardClick}
      >
        <div className={styles.wrapper}>
          <div className={styles.airportWrapper}>
            <RadioButtonGroup value={airportCode}>
              <RadioButton value={airportCode} />
            </RadioButtonGroup>
            <Typography variant="body-m-regular-tight">{airportName}</Typography>
          </div>
          <Divider className={styles.divider} />
          <RichText
            innerHTML={intl.formatMessage({ id: 'product_card_departure_airport_information' })}
          />
        </div>
        <div className={styles.footer}>
          <Button onClick={() => setIsOpened(false)} fullWidth>
            {intl.formatMessage({ id: 'close' })}
          </Button>
        </div>
      </Popover.Content>
    </Popover.Root>
  )
}
